import * as graphql from 'generated/graphql';

import BulkModal from './BulkModal';

export default function BulkResendActivationMailModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const [send] = graphql.useSendTemporaryPasswordMutation();

	return (
		<BulkModal
			name="resendActivationMail"
			users={props.users}
			onDismiss={props.onDismiss}
			apply={async (user) => {
				try {
					await send({ variables: { input: { userID: user.id } } });
				} catch (_) {}
			}}
		/>
	);
}
